import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { deletePictureAction, picturesActions } from '../actions';

const mapDispatchToProps = (dispatch: Dispatch) => ({
  setMainPicture: (pictureId: string) =>
    dispatch(picturesActions.setMainPicture(pictureId)),
  deletePicture: (pictureId: string) =>
    dispatch(deletePictureAction(pictureId)),
});

export type IDeletePictureContainerProps = ReturnType<
  typeof mapDispatchToProps
>;

export const editPictureContainerFactory = connect(null, mapDispatchToProps);
